<template>
    <v-app style="background-color: #ECEFF1;">
        <notifications group='gral_notif' position='bottom right' :width="400" />
        <v-app-bar color="teal darken-3" app dark>
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
            <!-- <v-spacer></v-spacer> -->
            <v-toolbar-title class="headline text-uppercase">
                <span>{{appName}}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <notificaciones-btn :apps="apps"/> -->
            <!-- <menu-apps :apps="apps"/> -->
            <menu-preferencias 
                @cambiarPass="cambiarPass=true"
            />
            <!-- <v-btn icon @click="cerrarSesion()">
                <v-icon>mdi-power</v-icon>
            </v-btn> -->
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            color="teal darken-3"
            :expand-on-hover="false"
            :mini-variant="false"
            :right="false"
            app
            dark
        >
            <left-menu :menu="menu"
            @cerrarMenu="drawer=false"/>
        </v-navigation-drawer>

        <main-footer />

        <main-content/>

        <cambiar-password
            v-if="cambiarPass"
            :mostrar="cambiarPass"
            @cancelar="cambiarPass=false"
        />


    </v-app>
</template>

<script>
import { mapGetters} from 'vuex'

// import MenuApps from './menuApps'
// import NotificacionesBtn from './notificacionesBtn'
import MenuPreferencias from './menuPreferencias'
import LeftMenu from './leftMenu'
import MainContent from './mainContent'
import MainFooter from './mainFooter'
import CambiarPassword from '../usuarios/cambiarPassword'
import axios from 'axios'

export default {
    props:['appName'],
    components:{
        // MenuApps,
        // NotificacionesBtn,
        MenuPreferencias,
        LeftMenu,
        MainContent,
        MainFooter,
        CambiarPassword
    },
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ])
    },
    created(){
        if( sessionStorage.getItem("token") )
            this.$store.dispatch("setSessionToken", sessionStorage.getItem("token"));
        if( localStorage.getItem("token") )
            this.$store.dispatch("setSessionToken", localStorage.getItem("token"));
        if( !this.sessionToken )
            this.$router.push('/login');
        axios.get(this.httpURL+'/login',{headers:{token:this.sessionToken}})
            .then(res => {
                //console.log(res.data);
                if( res.data.ok){
                    this.$store.dispatch("setUserName", res.data.nombre);
                    this.$store.dispatch("setPermisos", res.data.permisos);
                    this.$store.dispatch("setRole", res.data.role);
                    this.$store.dispatch("setSoloLectura", res.data.soloLectura);
                    this.$store.dispatch("setUserId", res.data.id);
                    this.$store.dispatch("setUserCodigo", res.data.codigo);
                    this.apps = res.data.apps;
                    this.escuela = res.data.escuela;
                    this.menu = res.data.menu;
                }else{
                    localStorage.removeItem("token");
                    sessionStorage.removeItem("token");
                    this.$router.push('/login');
                }
            })
            .catch(error => {
                // console.log('Error: '+error);
                localStorage.removeItem("token");
                sessionStorage.removeItem("token");
                if(error.response)
                    this.$router.push('/login');
            });
    },
    data: () => ({
        drawer: false,
        loading: false,
        menu:[],
        apps:[],
        cambiarPass: false
    }),
    methods:{
        // cerrarSesion(){
        //     localStorage.removeItem('token');
		// 	sessionStorage.removeItem('token');
		// 	this.$store.dispatch("setSessionToken", null);
		// 	this.$router.push('/login');
        // }
    }
}
</script>